import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

// eslint-disable-next-line react/prefer-stateless-function
class TaskStatBlock extends Component {
  constructor(props) {
    super(props);

    // Сортировка статусов по названию и разбитие на 2 массива для 2х колонок.
    const sortedStatusesAsArray = _.sortBy(
      Object.values(this.props.tasksExecsStat.statuses),
      [i => i.execStatusTitle]
    );
    const halfKey = Math.ceil(sortedStatusesAsArray.length / 2);
    this.statusesAsArrayColumn1 = sortedStatusesAsArray.slice(0, halfKey);
    this.statusesAsArrayColumn2 = sortedStatusesAsArray.slice(
      halfKey,
      sortedStatusesAsArray.length
    );
  }
  render() {
    return (
      <div className="row offset_bottom offset_bottom_xs">
        <div className="col-xs-24 col-sm-12">
          <dl className="dl-options dl-options-sm dl-horizontal">
            {this.statusesAsArrayColumn1.map(item => (
              <React.Fragment
                key={`tabStatistic-${this.props.taskId}-${item.execStatusId}`}
              >
                <dt>{item.execStatusTitle}:</dt>
                <dd>
                  <NavLink
                    to={`/my-tasks/view/${this.props.taskId}/executions/${item.execStatusId}`}
                  >
                    {item.execCountByStatus}
                  </NavLink>
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </div>
        <div className="col-xs-24 col-sm-12">
          <dl className="dl-options dl-options-sm dl-horizontal border border-l">
            {this.statusesAsArrayColumn2.map(item => (
              <React.Fragment
                key={`tabStatistic-${this.props.taskId}-${item.execStatusId}`}
              >
                <dt>{item.execStatusTitle}:</dt>
                <dd>
                  <NavLink
                    to={`/my-tasks/view/${this.props.taskId}/executions/${item.execStatusId}`}
                  >
                    {item.execCountByStatus}
                  </NavLink>
                </dd>
              </React.Fragment>
            ))}
            <dt title={this.props.tasksExecsStat.free_executions_slots.desc}>
              {this.props.tasksExecsStat.free_executions_slots.desc}:
            </dt>
            <dd>{this.props.tasksExecsStat.free_executions_slots.count}</dd>
          </dl>
        </div>
      </div>
    );
  }
}

TaskStatBlock.propTypes = {
  taskId: PropTypes.number.isRequired,
  tasksExecsStat: PropTypes.shape({
    statuses: PropTypes.shape({}).isRequired,
    free_executions_slots: PropTypes.shape({
      desc: PropTypes.string,
      count: PropTypes.number
    }).isRequired
  }).isRequired
};

export default withRouter(TaskStatBlock);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskStatBlock/TaskStatBlock.js